/**
 * Apparel Section JavaScript
 * Handles product slider for both desktop and mobile
 */

class ApparelSection {
  constructor(element) {
    this.element = element;
    this.slider = this.element.querySelector('[data-slider]');
    this.prevButton = this.element.querySelector('.apparel-section__slider-button--prev');
    this.nextButton = this.element.querySelector('.apparel-section__slider-button--next');
    
    if (this.slider && this.prevButton && this.nextButton) {
      this.init();
    }
  }

  init() {
    this.products = this.slider.querySelectorAll('.apparel-section__product');
    if (this.products.length === 0) return;
    
    this.currentIndex = 0;
    
    // Add event listeners
    this.prevButton.addEventListener('click', () => this.slidePrev());
    this.nextButton.addEventListener('click', () => this.slideNext());
    
    // Update on window resize
    this.resizeHandler = () => this.updateSlider();
    window.addEventListener('resize', this.resizeHandler);
    
    // Initialize button states
    this.updateSlider();
    
    // Add drag scrolling for desktop
    this.initDragScroll();
  }

  getSlideWidth() {
    if (this.products.length === 0) return 0;
    const gap = parseFloat(getComputedStyle(this.slider).gap) || 0;
    return this.products[0].offsetWidth + gap;
  }

  updateSlider() {
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    const scrollPosition = this.currentIndex * this.getSlideWidth();
    
    this.slider.scrollTo({
      left: scrollPosition,
      behavior: 'smooth'
    });
    
    // Update button states
    this.prevButton.disabled = this.currentIndex === 0;
    this.nextButton.disabled = scrollPosition >= maxScroll - 10;
  }

  slideNext() {
    const slideWidth = this.getSlideWidth();
    const visibleItems = Math.floor(this.slider.clientWidth / slideWidth);
    const maxIndex = this.products.length - visibleItems;
    
    if (this.currentIndex < maxIndex) {
      this.currentIndex++;
      this.updateSlider();
    }
  }

  slidePrev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateSlider();
    }
  }

  initDragScroll() {
    let isDown = false;
    let startX;
    let scrollLeft;

    this.slider.addEventListener('mousedown', (e) => {
      isDown = true;
      this.slider.style.cursor = 'grabbing';
      startX = e.pageX - this.slider.offsetLeft;
      scrollLeft = this.slider.scrollLeft;
    });

    this.slider.addEventListener('mouseleave', () => {
      isDown = false;
      this.slider.style.cursor = 'grab';
    });

    this.slider.addEventListener('mouseup', () => {
      isDown = false;
      this.slider.style.cursor = 'grab';
    });

    this.slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - this.slider.offsetLeft;
      const walk = (x - startX) * 2;
      this.slider.scrollLeft = scrollLeft - walk;
    });
  }

  destroy() {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
  }
}

// Initialize all apparel sections
function initApparelSections() {
  const sections = document.querySelectorAll('.apparel-section');
  sections.forEach(section => {
    new ApparelSection(section);
  });
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApparelSections);
} else {
  initApparelSections();
}

// Re-initialize when Shopify section is updated in the theme editor
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('apparel-section') || 
        event.target.querySelector('.apparel-section')) {
      initApparelSections();
    }
  });
}

// Export for potential use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = ApparelSection;

}
